'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { UseOverviewRailPreferenceResult } from '../common/use-overview-rail-preference';

// Lifted to `ClientHouseholdLayout` because the gear trigger and dialog aren't descendants of the
// Overview page body that owns the rail; a second hook instance would race the write cycle in
// `useOverviewRailPreference`.
const HouseholdOverviewRailPreferenceContext = createContext<UseOverviewRailPreferenceResult | null>(null);

type HouseholdOverviewRailPreferenceProviderProps = {
  readonly value: UseOverviewRailPreferenceResult;
  readonly children: ReactNode;
};

export function HouseholdOverviewRailPreferenceProvider({
  value,
  children,
}: HouseholdOverviewRailPreferenceProviderProps) {
  return (
    <HouseholdOverviewRailPreferenceContext.Provider value={value}>
      {children}
    </HouseholdOverviewRailPreferenceContext.Provider>
  );
}

export function useHouseholdOverviewRailPreference(): UseOverviewRailPreferenceResult {
  const value = useContext(HouseholdOverviewRailPreferenceContext);
  if (value === null) {
    throw new Error('useHouseholdOverviewRailPreference must be used within a ClientHouseholdLayout');
  }
  return value;
}
